// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1bm6_","simpleTitle":"styles_simpleTitle__2HRgZ"};